module.exports = __webpack_public_path__ + "img/wxCode.e4249ed5.jpg";